/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperationResult
 */
export interface OperationResult {
    /**
     * 
     * @type {boolean}
     * @memberof OperationResult
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OperationResult
     */
    message?: string | null;
}

/**
 * Check if a given object implements the OperationResult interface.
 */
export function instanceOfOperationResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperationResultFromJSON(json: any): OperationResult {
    return OperationResultFromJSONTyped(json, false);
}

export function OperationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasErrors': !exists(json, 'hasErrors') ? undefined : json['hasErrors'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function OperationResultToJSON(value?: OperationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasErrors': value.hasErrors,
        'message': value.message,
    };
}

